<template>
    <div class="ks-vue-component">
      <div class="form-group"
           :class="{ 'form-group--focus': hasFocus,
                     'view': forceView }">
        <input v-model="valueProxy"
               :id="id"
               @change="onChange"
               :value="val"
               class="form__checkbox"
               type="checkbox"
               @focus="onFocus"
               @blur="onBlur"
               :disabled="isDisabled" />
        <div class="form__label-wrap form__checkbox__label-wrap">
          <label class="form__label form__checkbox__label"
                 :class="{ 'form__checkbox__label-checked': checked,
                           'form__checkbox__label-unchecked': !checked }"
                 :for="id"><slot></slot></label>
        </div>
      </div>
      <!--<pre>{{ $v.value }}</pre>-->
    </div>
</template>

<script>
  import { includes, isUndefined } from 'lodash'

  export default {
    name: 'ks-checkbox',
    data () {
      return {
        hasFocus: false,
        valueProxy: this.value,
      }
    },
    computed: {
      showHelpText () {
        return !isUndefined(this.helpText)
      },
      showLabel () {
        return !isUndefined(this.label)
      },
      checked () {
        if (typeof this.valueProxy === 'boolean') {
          return this.valueProxy
        } else {
          return includes(this.valueProxy, this.val)
        }
      },
      forceView () {
        return this.viewOnly
      },
      isDisabled () {
        return this.disabled || this.forceView
      },
    },
    methods: {
      onBlur () {
        this.hasFocus = false
      },
      onChange () {
        this.$v.$touch()
        this.$emit('input', this.valueProxy)
      },
      onFocus () {
        this.hasFocus = true
      },
    },
    props: {
      id: {
        // This must be given to make this component work.
        type: String,
        required: true,
      },
      val: {
        // Corresponds with the value that gets put into the v-model if
        // given an array. See: https://vuejs.org/v2/guide/forms.html#Checkbox
      },
      value: {
        // Corresponds with v-model. This will hold the initial value
        // from the v-model property.
      },
      disabled: {
        // Disables the component
        type: Boolean,
        default: false,
      },
      $v: {
        // Vuelidate object
        type: Object,
        required: true,
      },
      viewOnly: {
        // Sets the component to "view only".
        type: Boolean,
        default: false,
      },
    },
  }

</script>

<style lang="scss">
  .ks-vue-component > .form-group.view {
    pointer-events: none;
  }
</style>
